import React from 'react';

/**
 * Rows of text as a table: the first row is the header (kept in view
 * while scrolling down) and the rest are records. Short rows are padded
 * so every cell sits under its column. Used for a CSV and for each sheet
 * of a workbook.
 *
 * `truncated` says rows past `limit` were left out, and the table says
 * so - the original file has them all (Download).
 */
function DocumentTable({ rows, truncated, limit, emptyMessage }) {
  const [header, ...records] = rows;

  if (!header) {
    return <p className="backend-document-meta">{emptyMessage}</p>;
  }

  const columnCount = Math.max(...rows.map((row) => row.length));
  const cells = (row) => Array.from({ length: columnCount }, (_, index) => row[index] ?? '');

  return (
    <>
      {truncated && (
        <p className="backend-document-meta">
          Showing the first {limit} rows. Download the file to see everything.
        </p>
      )}
      <div className="document-table-view">
        <table className="document-table">
          <thead>
            <tr>
              {cells(header).map((cell, index) => (
                // Columns are positional and never reorder, so the index is the key.
                <th key={index}>{cell}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {records.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {cells(row).map((cell, index) => (
                  <td key={index}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default DocumentTable;
